package com.nonopn.skywatcher.common.login

import com.nonopn.skywatcher.common.login.pages.RouterMain
import com.nonopn.skywatcher.design.appbar.AppBarState
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigationListener
import eu.codlab.navigation.NavigatorModel
import eu.codlab.viewmodel.StateViewModel
import eu.codlab.viewmodel.launch

data class OpenSessionState(
    var scene: NavigateTo = RouterMain.navigateTo()
)

private var ID = 1

data class OpenSessionModel(
    val id: Int = ID++,
    val nothing: Boolean = true
) : NavigationListener, StateViewModel<OpenSessionState>(OpenSessionState()) {
    companion object {
        fun fake(): OpenSessionModel = OpenSessionModel()
    }

    var navigator: NavigatorModel? = null

    fun show(scene: NavigateTo) = launch {
        navigator?.navigateTo(scene)
        updateState {
            copy(scene = scene)
        }
    }

    override fun shown(navigateTo: NavigateTo) {
        // nothing
    }

    override fun setAppBarState(appBarState: AppBarState) {
        // nothing
    }
}
